export default function convertMinuteToHour(totalMinutes) {
  if (typeof totalMinutes !== 'number' || totalMinutes < 0) {
    return "Invalid input";
  }

  // Calculate the number of hours using Math.floor for the integer part
  const hours = Math.floor(totalMinutes / 60);
  const hourText = app.translator.trans('ziven-community-core.forum.hour');
  const minuteText = app.translator.trans('ziven-community-core.forum.minute');
  const s = app.translator.trans('ziven-community-core.forum.s');

  // Calculate the remaining minutes using the modulo operator (%)
  const minutes = totalMinutes % 60;

  // Construct the result string, handling singular/plural forms
  let result = '';
  if (hours > 0) {
    result += "".concat(hours).concat(hourText).concat(hours === 1 ? '' : s);
  }
  if (minutes > 0) {
    result += "".concat(minutes).concat(minuteText).concat(minutes === 1 ? '' : s);
  }

  // Handle the case where totalMinutes is 0
  if (result === '') {
    return "0" + minuteText;
  }
  return result.trim();
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/convertMinuteToHour', convertMinuteToHour);